import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-349dc8a9"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "home",
  class: "front-view-wrapper container"
}
const _hoisted_2 = { class: "row d-flex align-items-center title-wrapper" }
const _hoisted_3 = { class: "col" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col text-center" }, [
    /*#__PURE__*/_createElementVNode("h2", null, [
      /*#__PURE__*/_createTextVNode("Avatar"),
      /*#__PURE__*/_createElementVNode("span", { class: "title-color" }, "Dex")
    ])
  ])
], -1))
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col ps-2 ps-md-5 ms-md-3 mt-1 mb-2 text-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row text-center small text-muted" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
    /*#__PURE__*/_createTextVNode(" Don't have an account? "),
    /*#__PURE__*/_createElementVNode("a", { href: "/0x5c3e5c1b3d62167986e660dabd7f7f1478df66ec" }, "View a demo")
  ])
], -1))

import SearchBar from "@/components/SearchBar.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

setTimeout(() => {
    const elem = document.getElementById("home");

    if (elem) {
        elem.style.display = "block";
    }
}, 500);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(SearchBar)
          ])
        ]),
        _hoisted_7
      ])
    ])
  ]))
}
}

})